import { Menu, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { BellIcon } from 'react-line-awesome';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { UserState, TAUser } from '@/reducers/currentUserReducer';
import { RootState } from '@/reducers/rootReducer';

import { UserAvatar } from './UserAvatar';

const TopNav = ({ children }: {children?: React.ReactNode}) => {
  return (
    <nav className="sticky top-0 z-50">
      <div className='w-full bg-white'>
        <div className="max-w-screen-xl mx-auto flex items-center justify-between" style={{ height: 60, minHeight: 60, maxHeight: 60 }}>
          <a href="/">
            <img alt="logo" src="/assets/media/logos/talk.svg" />
          </a>
          {children}
        </div>
      </div>
    </nav>
  );
};

interface NavItemProps {
  name: string;
  link: string;
  reloadDocument?: boolean;
}

const NavItem = ({ name, link, reloadDocument = false }: NavItemProps) => {
  return (
    <NavLink to={link} reloadDocument={reloadDocument} style={{ margin: "0 3.25px", fontSize: "13.975px", letterSpacing: "0.05px", padding: 8 }} className={({ isActive }) => `flex font-medium items-center text-shark rounded bg-white hover:bg-lavender-blush hover:text-carnation-400 group ${isActive ? "bg-lavender-blush" : ""}`}>
      {name}
    </NavLink>
  );
};

export const PublicTopNav = () => {
  return (
    <TopNav>
    </TopNav>
  );
};

export const UserTopNav = () => {
  const { attributes } = useSelector<RootState, UserState<TAUser>>(state => state.user as UserState<TAUser>);
  
  return (
    <TopNav>
      <div className='flex items-center'>
        <NavItem name="Home" link="/" reloadDocument />
        <NavItem name="Events" link="/events" reloadDocument />
        <NavItem name="Forums" link={`/chapter/${attributes?.groupSlug}/forums`} reloadDocument /> 
        <NavItem name="Polls" link="/polls" reloadDocument />
        <NavItem name="Members" link="/members" reloadDocument />
        <NavItem name="Vendors" link="/products" />
        <NavItem name="Agency Directory" link="https://www.recruiterdirect.com/" reloadDocument />
        <NavItem name="Chats" link="/chat" reloadDocument />
        {/* TODO */}
        {/* <span><BellIcon variant="regular" size="lg" className="p-2 rounded text-limed-spruce-800 hover:bg-red-100" /></span> */}
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button className="inline-flex w-full justify-center">
            <UserAvatar height={50} />
          </Menu.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >

            <Menu.Items className="origin-top-right absolute right-0 bg-white rounded border border-iron-300 mt-3 py-1">
              <div className='w-40'>
                <Menu.Item>
                  <a href="/settings" className="block px-4 py-2 hover:bg-gray-100 text-shark">My Profile</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="/notification_settings" className="block px-4 py-2 hover:bg-gray-100 text-shark">My Notifications</a>
                </Menu.Item>
                <Menu.Item>
                  <a href="/logout" className="block px-4 py-2 hover:bg-gray-100 text-shark">Sign out</a>
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </TopNav>
  );  
};

export const VendorTopNav = () => {
  return (
    <TopNav>
      <div className='flex items-center'>
        <NavItem name="Home" link="/newsfeed" reloadDocument />
        <NavItem name="Vendors" link="/products" />
        <NavItem name="Product Profile" link="/vendor/profile" />
        <Menu as="div" className="relative inline-block text-left pl-4">
          <Menu.Button className="inline-flex w-full justify-center rounded-full">
            <UserAvatar height={50} />
          </Menu.Button>
            
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >

            <Menu.Items className="origin-top-right absolute right-0 bg-white rounded border border-iron-300 mt-3 py-1">
              <div className='w-40'>
                <Menu.Item>
                  <a href="/logout" className="block px-4 py-2 hover:bg-gray-100 text-shark">Sign out</a>
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </TopNav>
  );
};

export default TopNav;
